import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { PopupNotificationOptions } from '@/modules/Notifications/interfaces/PopupNotificationOptions';

interface Props {
    options: PopupNotificationOptions;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupNotification',
  props: {
    options: null
  },
  setup(__props: any) {

const props = __props as {
    options: PopupNotificationOptions;
};



const icon = computed(
    () => props.options.icon || (props.options.errorType === 'error' ? 'close-circle' : 'exclamation-circle'),
);

const color = computed(() => 'color:' + (props.options.errorType === 'error' ? '#f5222d' : '#ffbf00'));

return { __sfc: true,props, icon, color }
}

})